import { render, staticRenderFns } from "./WasteNumberView.vue?vue&type=template&id=c902ca5e&"
import script from "./WasteNumberView.vue?vue&type=script&lang=js&"
export * from "./WasteNumberView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports